module.exports = __webpack_public_path__ + "img/works_img20022501.998e54bf.jpg";